import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {PointByPointImportantPointApiModel} from "./point-by-point.important-point.api-model";
import {CompetitorDomainModel} from "../../../common/competitor/models/competitor-domain-model";

export class PointByPointImportantPointDomainModel extends BaseDomainModel {
  apiModel: PointByPointImportantPointApiModel;

  constructor(model: PointByPointImportantPointApiModel, competitors: Map<Number, CompetitorDomainModel>) {
    super(model);

    this.competitors = competitors;
    this.type = model.type;
    this.competitorId = model.competitorId;
  }

  get competitor() {
    return this.competitors?.get(this.competitorId) || null
  }
}
